<template>
  <div class="table-header-editor">
    <el-dropdown ref="dropdown" :hide-on-click="false" trigger="click">
      <span class="el-dropdown-link">
        <div class="icon">
          <i class="el-icon-s-grid"></i>
        </div>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <!-- 全部 -->
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkedAll" @change="handleCheckAllChange">全选</el-checkbox>
        </el-dropdown-item>
        <el-dropdown-item divided=""></el-dropdown-item>
        <el-dropdown-item v-for="(item, index) in originHeaders" :key="index">
          <el-checkbox v-model="item.checked" :disabled="item.disabled">{{item.label}}</el-checkbox>
        </el-dropdown-item>
        <el-dropdown-item divided></el-dropdown-item>
        <div class="handle-btn">
          <!-- 确认 -->
          <el-button @click="confirmSelect()">确认</el-button>
          <!-- 还原 -->
          <el-button @click="recoverySelect()">重置</el-button>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'TableHeaderEditor',
  props: {
    headers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isIndeterminate: false,
      checkedAll: true,
      originHeaders: [],
      checkTimer: null
    }
  },
  watch: {
    // headers: {
    //   deep: true,
    //   handler(newVal) {
    //     if (newVal.length > 0) {
    //       this.copyHeaders()
    //     }
    //   }
    // },
    originHeaders: {
      deep: true,
      handler(newValue) {
        const checked = newValue.filter(i => i.checked).length
        const total = this.originHeaders.length
        if (checked === total) {
          this.checkedAll = true
          this.isIndeterminate = false
        } else if (checked === 0) {
          this.checkedAll = false
          this.isIndeterminate = false
        } else {
          this.checkedAll = false
          this.isIndeterminate = true
        }
      }
    }
  },
  mounted() {
    this.copyHeaders()
    this.confirmSelect()
  },
  methods: {
    clearTimer() {
      if (this.checkTimer) {
        clearTimeout(this.checkTimer)
        this.checkTimer = null
      }
    },
    copyHeaders() {
      // 复制一份新的数组
      this.clearTimer()
      if (this.headers.length === 0) {
        this.checkTimer = setTimeout(() => {
          this.copyHeaders()
        }, 500)
      } else {
        this.originHeaders = this.headers.concat([])
      }
    },
    handleCheckAllChange(val) {
      // 切换全选，反选
      if (val) {
        this.originHeaders.forEach(i => {
          this.$set(i, 'checked', true)
        })
      } else {
        this.originHeaders.forEach(i => {
          this.$set(i, 'checked', false)
        })
      }
    },
    confirmSelect() {
      // 确认编辑表头
      this.originHeaders.forEach((origin, originIndex) => {
        if (origin.checked) { // 向列表中添加项
          if (this.headers.filter(h => h.id === origin.id).length === 0) {
            const length = originIndex + 1 // 检查缺失的项在原始数据中的位置，根据当前列表中这个位置前面的数量来确定需要添加的位置
            let index = 0
            for (let i = 0; i < length; i++) {
              if(this.headers.filter(h => h.id === this.originHeaders[i].id).length === 1) {
                index += 1
              }
            }
            
            this.headers.splice(index, 0, origin)
          }
        } else { // 从列表中移除项
          if (this.headers.filter(h => h.id === origin.id).length === 1) {
            let index = 0
            this.headers.forEach((head, headindex) => {
              if (head.id === origin.id) {
                index = headindex
              }
            })

            this.headers.splice(index, 1)
          }
        }
      })

      this.$refs.dropdown.hide()
    },
    recoverySelect() {
      // 恢复全选
      this.originHeaders.forEach(i => {
        this.$set(i, 'checked', true)
      })

      this.confirmSelect()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common.scss';
  .table-header-editor {
    .icon {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: 1px solid #dcdfe6;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      cursor: pointer;
      &:hover {
        i {
          color: $main_color_deep;
        }
      }
      i {
        padding: 0 !important;
        margin: 0 !important;
      }
    }
  }
</style>